export const DEFAULT_CLASS_PREFIX = 'country-select';

export const INIT = 'INIT';
export const FOCUS = 'FOCUS';
export const BLUR = 'BLUR';
export const TEXT_CHANGE = 'TEXT_CHANGE';
export const ACTIVE_LIST_ITEM_CHANGE = 'ACTIVE_LIST_ITEM_CHANGE';
export const COUNTRY_SELECT = 'COUNTRY_SELECT';
export const CLEAR = 'CLEAR';
